const attributeDisplayKey = (attr) => {
  const label = (attr.attribute_label || attr.attribute_name || "")
    .trim()
    .toLowerCase();

  return label || `id:${attr.attribute_id}`;
};

const preferAttribute = (existing, candidate) => {
  const existingHasValue =
    existing.attribute_value != null && existing.attribute_value !== "";
  const candidateHasValue =
    candidate.attribute_value != null && candidate.attribute_value !== "";

  if (candidateHasValue && !existingHasValue) {
    return candidate;
  }

  if (Number(candidate.attribute_id) < Number(existing.attribute_id)) {
    return candidate;
  }

  return existing;
};

export const dedupeCustomerAttributes = (attributes) => {
  const byKey = new Map();

  for (const attr of attributes || []) {
    const key = attributeDisplayKey(attr);
    const existing = byKey.get(key);
    byKey.set(key, existing ? preferAttribute(existing, attr) : attr);
  }

  return Array.from(byKey.values());
};

export const buildAttrsFromCustomerAttributes = (attributes) => {
  const initialAttrs = {};

  dedupeCustomerAttributes(attributes).forEach((attr) => {
    if (attr.is_input === 1 || attr.is_input === true) {
      initialAttrs[attr.attribute_id] = attr.attribute_value ?? "";
    }
  });

  return initialAttrs;
};
